import { useEffect, useRef, useState } from "react"
import DownloadIcon from '../assets/svg/download.svg?react'
import { server } from "../pages/chat/Server.js"

export default function DownloadButton({ strId, title, tooltip = '', buttonDisabled }) {

    const [download, setDownload] = useState({ status: 'idle' });
    const buttonRef = useRef(null);

    useEffect(() => {
        if (download.status === 'done') {
            buttonRef.current.click()
            return () => {
                window.URL.revokeObjectURL(download.url)
            }
        }
        if (download.status !== 'run') {
            return
        }
        server.api(`strategy/code/get`, { strId }).then(content => {
            const dataUrl = new Blob([content], { type: 'text/plain' })
            const url = window.URL.createObjectURL(dataUrl)
            setDownload({ status: 'done', url })
        }).catch(() => {
            alert('Error downloading code')
            setDownload({ status: 'idle' })

        })
    }, [strId, download])

    function handleClick(e) {
        e.preventDefault()
        if (buttonDisabled || download.status !== 'idle') {
            return;
        }
        setDownload({ status: 'run' })
    }


    const isClickable = !buttonDisabled && download.status === 'idle';
    const baseClasses = 'inline-flex items-center justify-center gap-2 h-8 px-3 rounded-md text-label transition-colors';

    const stateClasses = buttonDisabled
        ? 'border border-border bg-transparent text-text-disabled cursor-not-allowed'
        : 'cursor-pointer';
    // const stateClasses = buttonDisabled
    //     ? 'border border-border bg-transparent text-text-disabled cursor-not-allowed'
    //     : 'bg-primary text-primary-foreground hover:bg-primary/90 cursor-pointer';


    const href = download.status === 'done' ? download.url : '#'
    const filename = download.status === 'done' ? `str-${strId}.mq5` : null

    return (
        <a ref={buttonRef} href={href} download={filename} className={`${baseClasses} ${stateClasses}`} onClick={isClickable ? handleClick : null} title={tooltip} aria-disabled={buttonDisabled} tabIndex={buttonDisabled ? -1 : 0}><DownloadIcon /> <span className="download-title">{title}</span>{download.status === 'run' ? '...' : ''}</a>
    )

}
